import * as actionTypes from '../../actionTypes';
import {contactInGroups} from '../../helpers/contacts';
import {companyInGroups, findGrouping} from '../../helpers/companies';
import _ from 'lodash';

export const initialState = {
  applicants: {
    list: {},
    search: {},
    pinned: []
  },
  contacts: {
    searchTerms: [],
    filters: {},
    pinned: [],
    page: 0,
    pageSize: 25,
  },
  companies: {
    searchTerms: [],
    filters: {},
    pinned: []
  },
  jobRequests: {
    searchTerms: [],
    filters: {},
    pinned: []
  },
  applicant: null,
  navColumnState: null
};

export default function adminReducer(state = initialState, action) {
  let clonedState;
  let contactInContactWorksheet;
  let index;
  switch (action.type) {
    case actionTypes.UPDATE_APPLICANTS_LIST :
      clonedState = _.cloneDeep(state);
      _.set(clonedState, 'applicants.search', action.applicants);
      return clonedState;

    case actionTypes.UPDATE_CONTACTS_LIST :
        clonedState = Object.assign({}, state, {
          contacts: action.contacts,
        });
        clonedState.contacts.pinned = state.contacts.pinned;
        clonedState.contacts.filters = state.contacts.filters || {};
        clonedState.contacts.searchTerms = state.contacts.searchTerms || [];
        return clonedState;

    case actionTypes.UPDATE_CONTACTS_PAGE :
      clonedState = Object.assign({}, state, {
        contacts: action.data,
      });
      clonedState.contacts.pinned = state.contacts.pinned;
      clonedState.contacts.filters = state.contacts.filters || {};
      clonedState.contacts.searchTerms = state.contacts.searchTerms || [];
      clonedState.contacts.page = state.contacts.page || 0;
      clonedState.contacts.pageSize = state.contacts.pageSize || 25;
      return clonedState;

    case actionTypes.UPDATE_COMPANIES_LIST :
      clonedState = Object.assign({}, state, {
        companies: action.companies,
      });
      clonedState.companies.pinned = state.companies.pinned;
      clonedState.companies.filters = state.companies.filters || {};
      clonedState.companies.searchTerms = state.companies.searchTerms || [];
      return clonedState;

    case actionTypes.UPDATE_COMPANIES_PAGE :
        clonedState = Object.assign({}, state, {
          companies: action.data,
        });
        clonedState.companies.pinned = state.companies.pinned;
        clonedState.companies.filters = state.companies.filters || {};
        clonedState.companies.searchTerms = state.companies.searchTerms || [];
        return clonedState;

    case actionTypes.UPDATE_COMPANY :
        clonedState = Object.assign({}, state);
        const criteriaCompany = { id: action.company.id};
        const existsInCompany = companyInGroups(criteriaCompany, clonedState.companies) || [];
        existsInCompany.map((group) => {
          if (group.name !== "items") {
            if (group === action.newGroup || group === 'pinned') {
              clonedState.companies[group.name][group.index] = action.company;
            } else {
              clonedState.companies[group.name].splice(group.index, 1);
            }
          } else {
            clonedState.companies[group.name][group.index] = action.company
          }
        });

        if (action.newGroup && !clonedState.companies[action.newGroup]) {
          clonedState.companies[action.newGroup] = [];
        }

        if (action.newGroup && action.newGroup !== 'pinned') {
          clonedState.companies[action.newGroup].push(action.company);
        }

        // TODO: Not sure we can just use the one from status list.
        clonedState.company = _.merge({}, clonedState.company, action.company);

        return clonedState;

    case actionTypes.CLEAR_CONTACT_IN_CONTACT_WORKSHEET:
      return { ...state, contactInContactWorksheet: {} };

    case actionTypes.UPDATE_CONTACT_IN_CONTACT_WORKSHEET:
      return { ...state, contactInContactWorksheet: _.merge({}, state.contactInContactWorksheet, action.contact) };

    case actionTypes.UPDATE_CONTACT :
      clonedState = Object.assign({}, state);
      const criteria = { profile: { id: action.contact.profile.id}};

      const contactIndex = _.findIndex(_.get(clonedState, 'contacts.items'), criteria);

      if(contactIndex === -1) {

        console.warn(
          `This contact cannot be found in 'admin.contacts' store. This could be because a misuse of this UPDATE_CONTACT action type (in certain cases).
          'admin.contacts' has all contacts of the current page of Contact Dashboard. The contact You're trying to update is not in this page.
          `);

        return clonedState;
      }

      _.set(clonedState, `contacts.items[${contactIndex}]`, action.contact);

      return clonedState;
    case actionTypes.UPDATE_APPLICANTS_PAGE :
        clonedState = _.cloneDeep(state);
        _.set(clonedState, `applicants.search.${action.group}`, action.data);
        return clonedState;

    case actionTypes.ADD_APPLICANT_ADMIN :
      clonedState = _.cloneDeep(state);

      const Group = _.get(action, 'applicant.profile.statusGroup');

      // Add new applicant to the top of group.
      if (Group && clonedState.applicants.search[Group]) {
        clonedState.applicants.search[Group].items.unshift(action.applicant);
        clonedState.applicants.search[Group].total ++;
      }

      return clonedState;

      case actionTypes.DELETE_APPLICANT_ADMIN:
        clonedState = _.cloneDeep(state);

        index = clonedState.applicants.search[action.group].items.findIndex((applicant) => applicant.profile.id === action.applicantId);
        // updating specific applicant
        if (~index) {
          clonedState.applicants.search[action.group].items.splice(index, 1);
          clonedState.applicants.search[action.group].total --;
        }

        // if applicant is pinned, update pinned copy
        index = clonedState.applicants.pinned.findIndex((applicant) => applicant.profile.id === action.applicantId);
        if (~index) {
          clonedState.applicants.pinned.splice(index, 1);
        }

        return clonedState;

    case actionTypes.UPDATE_APPLICANT_ADMIN:
      clonedState = _.cloneDeep(state);
      const newGroup = action.newGroup;
      const id = action.updatedApplicant.profile.id;

      index = clonedState.applicants.search[action.group].items.findIndex((applicant) => applicant.profile.id === id);
      let original = [];

      // updating specific applicant
      if (newGroup && newGroup !== action.group) {
        if (~index) {
          original = clonedState.applicants.search[action.group].items.splice(index, 1);
          clonedState.applicants.search[action.group].total --;
        }
        if (clonedState.applicants.search[newGroup] && clonedState.applicants.search[newGroup].items) {
          clonedState.applicants.search[newGroup].items.unshift(_.merge(!_.isEmpty(original) && original[0], action.updatedApplicant));
          clonedState.applicants.search[newGroup].total ++;
        }
      }
      else {
        _.mergeWith(clonedState.applicants.search[action.group].items[index], action.updatedApplicant, (dest, src) => {
          // CAN'T CHANGE STUFF TO NULL, WILL FIX LATER
          return _.merge(dest, src);
        });
      }

      // if applicant is pinned, update pinned copy
      index = clonedState.applicants.pinned.findIndex((applicant) => applicant.profile.id === action.updatedApplicant.profile.id);
      if (~index) {
        _.mergeWith(clonedState.applicants.pinned[index], action.updatedApplicant, (dest, src) => {
          // CAN'T CHANGE STUFF TO NULL, WILL FIX LATER
          return _.merge(dest, src);
        });
      }

      // update current applicant
      _.mergeWith(clonedState.applicant, action.updatedApplicant, (dest, src) => {
        // CAN'T CHANGE STUFF TO NULL, WILL FIX LATER
        return _.merge(dest, src);
      });


      return clonedState;

    case actionTypes.UPDATE_CURRENT_APPLICANT_ADMIN:
      clonedState = _.cloneDeep(state);
      clonedState.applicant = action.applicant;

      return clonedState;

    case actionTypes.UPDATE_EVENT_LIST :
      clonedState = _.cloneDeep(state);

      // updating applicant events (tasks, notes, notifications)
      const {
        event: {
          eventRoute,
          ...event
        }
      } = action;

      const applicantObj = clonedState.applicant;
      if (applicantObj.profile.id === event.applicantId && event.noteId) {
        if (!applicantObj.profile[eventRoute]) {
          applicantObj.profile[eventRoute] = []; // account for if value is null
        }

        applicantObj.profile[eventRoute].map(targetEvent => {
          if (targetEvent.id === event.noteId) {
            targetEvent.note = event.note;
            targetEvent.category = event.category;
            targetEvent.dateModified = Date();
          }
        });
      }
      else if (applicantObj.profile.id === event.applicantId && event.taskId) {
         if (!applicantObj.profile[eventRoute]) {
           applicantObj.profile[eventRoute] = []; // account for if value is null
         }

         applicantObj.profile[eventRoute].map(targetEvent => {
           if (targetEvent.id === event.taskId) {
             targetEvent.taskTypeId = event.taskTypeId;
             targetEvent.taskResultId = event.taskResultId;
             targetEvent.taskFollowUpDate = event.taskFollowUpDate;
             targetEvent.closed = event.closed;
             targetEvent.message = event.message;
           }
         });
       }
      else if (applicantObj.profile.id === event.applicantId) {
        if (!applicantObj.profile[eventRoute]) {
          applicantObj.profile[eventRoute] = []; // account for if value is null
        }

        applicantObj.profile[eventRoute].push(event);
      }

      return clonedState;

    case actionTypes.UPDATE_CONTACT_EVENT_LIST :

      // updating contact events (tasks, notes, notifications)

      clonedState = _.cloneDeep(state);
      contactInContactWorksheet = _.get(clonedState, 'contactInContactWorksheet', {});

      // For contactInContactWorksheet
      clonedState.contactInContactWorksheet = processEventList(contactInContactWorksheet, action);

      // For contacts.items
      clonedState.contacts.items =
        _(clonedState.contacts.items)
          .map((contactObj) => processEventList(contactObj, action))
          .value();

      return clonedState;

    case actionTypes.CHANGE_NAV_COLUMN_STATE :
      return Object.assign({}, state, {
        navColumnState: action.navColumnState
      });

    case actionTypes.UPDATE_PINNED_APPLICANTS:
      const newState = _.merge({}, state);
      const pinnedApplicant =  action.applicant;
      index = newState.applicants.pinned.findIndex((applicant) => applicant.profile.id === pinnedApplicant.profile.id);
      if (~index) {
        newState.applicants.pinned.splice(index, 1);
      }
      else {
        newState.applicants.pinned.push(pinnedApplicant);
      }

      return newState;

    case actionTypes.FETCH_PINNED_APPLICANTS:
      const admin = _.merge({}, state);
      const applicants = action.applicants;
      admin.applicants.pinned = applicants;

      return admin;

    case actionTypes.GET_COMPANY_INFO:
      const newCompany = action.company;
      const oldCompany = {...state.company};
      const companies = {...state.companies};
      const existsIn = companyInGroups({id: newCompany.id}, companies);
      const belongsIn = findGrouping({company:newCompany, groups:action.groups});
      let move = true;
      contactInContactWorksheet = _.get(state, 'contactInContactWorksheet', {});
      const contacts = _.get(state, 'contacts.items', []);

      existsIn.forEach(({name, index}) => (belongsIn.group !== name) ? companies[name].splice(index, 1) : (move = false));
      if (move) {
        if (!companies[belongsIn.group]) {
          companies[belongsIn.group] = [];
        }
        companies[belongsIn.group].push(newCompany);
      }

      const newContacts = _.map(contacts, (contact) => {

          if(contact.company.id === newCompany.id) {
              return {...contact, company: newCompany};
          }

          return contact;


      });

      return Object.assign({}, state, {
        companies,
        company: newCompany,
        contacts: {...state.contacts, items: newContacts},
        contactInContactWorksheet: {...contactInContactWorksheet, company: newCompany}
      });

    case actionTypes.UPDATE_CONTACTS_TABLE_SEARCH_TERMS:
      clonedState = _.cloneDeep(state);
      _.set(clonedState, 'contacts.searchTerms', action.searchTerms);
      return clonedState;

    case actionTypes.UPDATE_CONTACTS_TABLE_FILTERS:
      clonedState = _.cloneDeep(state);
      _.set(clonedState, 'contacts.filters', {});
      _.forEach(action.filters, (val, key) => {
        clonedState.contacts.filters[key] = val;
      });
      return clonedState;
    case actionTypes.UPDATE_COMPANIES_TABLE_FILTERS:
      clonedState = _.cloneDeep(state);
      _.set(clonedState, 'companies.filters', {});
      _.forEach(action.filters, (val, key) => {
        clonedState.companies.filters[key] = val;
      });
      return clonedState;
    case actionTypes.UPDATE_COMPANIES_TABLE_SEARCH_TERMS:
      clonedState = _.cloneDeep(state);
      _.set(clonedState, 'companies.searchTerms', action.searchTerms);
      return clonedState;
    case actionTypes.LOG_OUT:
      return initialState;

    case actionTypes.UPDATE_JOB_REQUESTS_FILTERS:
    
      clonedState = _.cloneDeep(state);
      _.set(clonedState, 'jobRequests.filters', {});
      _.forEach(action.filters, (val, key) => {
        clonedState.jobRequests.filters[key] = val;
      });

      return clonedState;

    case actionTypes.UPDATE_JOB_REQUESTS_TERMS:
      clonedState = _.cloneDeep(state);
      _.set(clonedState, 'jobRequests.searchTerms', action.searchTerms, []);
      return clonedState;

    case actionTypes.GO_TO_CONTACTS_PAGE:
      clonedState = _.cloneDeep(state);
      _.set(clonedState, 'contacts.page', action.page);
      return clonedState;
    default:
      return state;
  }
}

function processEventList(contactObj, action) {

  const {
      contactEvent: {
        contactEventRoute,
        ...contactEvent
      }
    } = action;

  if (contactObj.profile.id === contactEvent.contactId && contactEvent.noteId) {
    if (!contactObj.profile[contactEventRoute]) {
      contactObj.profile[contactEventRoute] = []; // account for if value is null
    }

    contactObj.profile[contactEventRoute].map(targetEvent => {
      if (targetEvent.id === contactEvent.noteId) {
        targetEvent.note = contactEvent.note;
        targetEvent.dateModified = Date();
      }
    });
  }
  else if (contactObj.profile.id === contactEvent.contactId && contactEvent.taskId) {
    if (!contactObj.profile[contactEventRoute]) {
      contactObj.profile[contactEventRoute] = []; // account for if value is null
    }

    contactObj.profile[contactEventRoute].map(targetEvent => {
      if (targetEvent.id === contactEvent.taskId) {
        targetEvent.closed = contactEvent.closed;
        targetEvent.noteTypeId = contactEvent.noteTypeId;
        targetEvent.taskTypeId = contactEvent.taskTypeId;
        targetEvent.taskResultId = contactEvent.taskResultId;
        targetEvent.taskResultOther = contactEvent.taskResultOther;
        targetEvent.taskFollowUpDate = contactEvent.taskFollowUpDate;
        targetEvent.message = contactEvent.message;
      }
    });
  }
  else if (contactObj.profile.id === contactEvent.contactId) {
    if (!contactObj.profile[contactEventRoute]) {
      contactObj.profile[contactEventRoute] = []; // account for if value is null
    }

    contactObj.profile[contactEventRoute].push(contactEvent);
  }

  return contactObj;
}



// WEBPACK FOOTER //
// ./shared/redux/reducers/admin/index.js